import React from 'react';
import { useSelector } from 'react-redux';

import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';

import { sendAnalytics } from '../../../utils/analytics';

const FinalityConfig = ({ config, changeFinality }) => {
  const finalities = useSelector((state) => state.actionsDrawer.finality);
  return (
    <div className='export-list-modal__step-2'>
      <Typography className='finality-config__title'>
        Finalidade de uso
      </Typography>

      <Typography className='finality-config__subtitle'>
        Escolha a opção que mais se enquadre no uso dos dados:
      </Typography>
      <FormControl variant='outlined' margin='dense' style={{ width: '500px' }}>
        <Select
          id='exportarLista-finalidade-select'
          value={config.finality.id ? config.finality : ''}
          onChange={changeFinality}
          displayEmpty
          renderValue={(selected) => {
            if (!selected || !selected.id) {
              return 'Selecione uma finalidade';
            }
            return selected.label;
          }}
          MenuProps={{ style: { width: '500px' } }}
        >
          {finalities.length &&
            finalities.map((f) => (
              <MenuItem
                key={f.id}
                id={`${f.label}-button`}
                className='finalidade-MenuItem'
                value={f}
                onClick={() =>
                  sendAnalytics({
                    event: `${f.label}-button`,
                    page: 'exportarLista',
                  })
                }
              >
                <div>
                  <Typography style={{ color: '#000000', fontSize: '14px' }}>
                    {f.label}
                  </Typography>

                  <Typography
                    style={{ color: '#00000080', fontSize: '12px' }}
                    gutterBottom
                  >
                    {f.description}
                  </Typography>
                </div>
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

FinalityConfig.defaultProps = {
  config: {
    params: [],
    fileExtension: 'csv',
    finality: { id: null, label: '', description: '' },
  },
};

export default FinalityConfig;
